import { render, staticRenderFns } from "./ComicBlock.vue?vue&type=template&id=6a5b766d&scoped=true&"
import script from "./ComicBlock.vue?vue&type=script&lang=js&"
export * from "./ComicBlock.vue?vue&type=script&lang=js&"
import style0 from "./ComicBlock.vue?vue&type=style&index=0&id=6a5b766d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5b766d",
  null
  
)

export default component.exports